<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      :beforeOpen="beforeOpen"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuLeft">
        <el-button v-if="canAction('add')" type="primary" icon="el-icon-plus" plain size="small" @click="handleAdd">新增</el-button>
        <el-button v-if="canAction('import')" type="primary" icon="el-icon-upload2" plain size="small" @click="onImport">导入</el-button>
        <el-button v-if="canAction('export')" type="primary" icon="el-icon-download" plain size="small" :loading="exportLoading" @click="handleExport">导出</el-button>
        <el-button v-if="canAction('import')" type="default" icon="el-icon-download" plain size="small" :loading="templateLoading" @click="handleTemplate">导入模板</el-button>
      </template>

      <template slot="finishStatus" slot-scope="{ row }">
        <el-tag size="small" :type="Number(row.finishStatus) === 1 ? 'success' : 'info'">{{ finishStatusLabel(row.finishStatus) }}</el-tag>
      </template>

      <template slot="attachments" slot-scope="{ row }">
        <div v-if="imageList(row.attachments).length" class="attachment-cell">
          <el-image class="attachment-thumb" :src="imageList(row.attachments)[0]" :preview-src-list="imageList(row.attachments)" fit="cover">
            <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
          </el-image>
          <span>{{ imageList(row.attachments).length }} 张图片</span>
        </div>
        <span v-else>-</span>
      </template>

      <template slot-scope="{ row,index }" slot="menu">
        <el-button v-if="canAction('view')" icon="el-icon-view" size="small" type="text" @click="showDetail(row)">详情</el-button>
        <el-button v-if="canAction('edit')" icon="el-icon-edit" size="small" type="text" @click="$refs.crud.rowEdit(row, index)">编辑</el-button>
        <el-button v-if="canAction('complete')" icon="el-icon-circle-check" size="small" type="text" @click="openComplete(row)">完成</el-button>
        <el-button v-if="canAction('delete')" icon="el-icon-delete" size="small" type="text" @click="$refs.crud.rowDel(row, index)">删除</el-button>
      </template>
    </avue-crud>

    <dialog-reset title="应急演练计划导入" :visible.sync="excelBox" height="auto" width="650px">
      <avue-form :option="excelOption" v-model="excelForm" :upload-after="uploadAfter">
        <template slot="excelTemplate">
          <el-button type="primary" :loading="templateLoading" @click="handleTemplate">
            点击下载<i class="el-icon-download el-icon--right"></i>
          </el-button>
        </template>
      </avue-form>
    </dialog-reset>

    <el-dialog
      title="完成应急演练"
      :visible.sync="completeVisible"
      width="640px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form label-width="100px" size="small">
        <el-form-item label="演练名称">
          <span>{{ completeRow.drillName || '-' }}</span>
        </el-form-item>
        <el-form-item label="附件图片">
          <el-upload
            class="drill-photo-upload"
            :action="uploadAction"
            :headers="uploadHeaders"
            :file-list="completeFiles"
            list-type="picture-card"
            accept="image/*"
            :before-upload="beforePhotoUpload"
            :on-success="handlePhotoSuccess"
            :on-remove="handlePhotoRemove"
            :on-preview="handlePhotoPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="form-tip">仅允许上传图片；已完成后可继续追加、删除、重新上传。</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="completeVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="completeLoading" @click="submitComplete">确定完成</el-button>
      </span>
    </el-dialog>

    <dialog-reset slotShow height="60vh" top="8vh" width="760px" title="应急演练计划详情" :visible.sync="detailVisible">
      <div v-loading="detailLoading" class="detail-dialog">
        <template v-if="detail">
          <div class="detail-grid">
            <div v-for="item in detailFields" :key="item.label" class="detail-item" :class="{ 'detail-item--wide': item.wide }">
              <span class="detail-item__label">{{ item.label }}</span>
              <span class="detail-item__value">{{ item.value || '-' }}</span>
            </div>
          </div>
          <div class="detail-section">
            <div class="detail-section__title">附件图片</div>
            <div v-if="imageList(detail.attachments).length" class="image-list">
              <el-image v-for="(url, index) in imageList(detail.attachments)" :key="url + index" class="detail-image" :src="url" :preview-src-list="imageList(detail.attachments)" fit="cover">
                <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
              </el-image>
            </div>
            <el-empty v-else description="暂无附件图片" />
          </div>
        </template>
        <el-empty v-else-if="!detailLoading" description="暂无详情数据" />
      </div>
      <span slot="dialog_footer">
        <el-button size="small" type="primary" @click="detailVisible = false">关闭</el-button>
      </span>
    </dialog-reset>

    <el-dialog :visible.sync="previewVisible" append-to-body width="720px">
      <img :src="previewUrl" class="preview-image" alt="">
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { mapGetters } from 'vuex'
import { getList, add, update, remove, getDetail, complete, downloadImportTemplate, exportExcel } from './api'
import { getSearchTimeConfig, rulesInput } from '@/basic-common/util/common'
import { downloadXls } from '@/util/util'
import { getToken } from '@/util/auth'
import website from '@/config/website'

const FINISH_STATUS_OPTIONS = [
  { label: '未完成', value: 0 },
  { label: '已完成', value: 1 }
]

export default {
  name: 'EmergencyDrillPlan',
  mixins: [crudMixins],
  data () {
    const that = this
    return {
      form: {},
      excelForm: {},
      excelBox: false,
      templateLoading: false,
      exportLoading: false,
      completeVisible: false,
      completeLoading: false,
      completeRow: {},
      completeFiles: [],
      detailVisible: false,
      detailLoading: false,
      detail: null,
      previewVisible: false,
      previewUrl: '',
      apiConfig: { getList, add, update, remove, getDetail },
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '文件上传',
            prop: 'excelFile',
            type: 'upload',
            drag: true,
            loadText: '文件上传中，请稍等',
            showFileList: false,
            propsHttp: {
              res: 'data'
            },
            tip: '请上传 .xls,.xlsx 标准格式文件',
            action: '/api/produce/emergency-drill-plan/import-excel'
          },
          {
            label: '模板下载',
            prop: 'excelTemplate',
            formslot: true
          }
        ]
      },
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        selection: false,
        addBtn: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        menuWidth: 240,
        column: [
          {
            label: '演练名称',
            prop: 'drillName',
            search: true,
            overHidden: true,
            minWidth: 180,
            maxlength: 128,
            rules: rulesInput(1)
          },
          {
            label: '演练日期',
            prop: 'drillDate',
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            overHidden: true,
            width: 130,
            rules: rulesInput(2)
          },
          {
            label: '演练主题',
            prop: 'drillSubject',
            type: 'textarea',
            overHidden: true,
            minWidth: 180,
            maxlength: 500,
            span: 24,
            minRows: 3
          },
          {
            ...getSearchTimeConfig('日期范围', { prop: 'drillDateRange', type: 'daterange' }),
            searchValue: [],
            paramsKey: ['startTime', 'endTime']
          },
          {
            label: '组织部门',
            prop: 'organizeDeptId',
            type: 'tree',
            search: true,
            checkStrictly: true,
            overHidden: true,
            minWidth: 150,
            dicUrl: '/api/blade-system/dept/treeByUser',
            props: {
              label: 'deptName',
              value: 'id',
              children: 'children'
            },
            formatter: (row) => row.organizeDeptName || that.deptLabel(row.organizeDeptId),
            change: ({ value }) => {
              that.syncDeptName(value)
            }
          },
          {
            label: '组织部门名称',
            prop: 'organizeDeptName',
            hide: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false
          },
          {
            label: '完成状态',
            prop: 'finishStatus',
            type: 'select',
            search: true,
            slot: true,
            dicData: FINISH_STATUS_OPTIONS,
            width: 110,
            addDisplay: false,
            editDisplay: false
          },
          {
            label: '附件',
            prop: 'attachments',
            slot: true,
            minWidth: 130,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false
          },
          {
            label: '创建时间',
            prop: 'createTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            width: 170,
            addDisplay: false,
            editDisplay: false
          },
          {
            label: '更新时间',
            prop: 'updateTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            width: 170,
            addDisplay: false,
            editDisplay: false
          }
        ]
      },
      defaultParams: {}
    }
  },
  computed: {
    ...mapGetters(['permission']),
    uploadAction () {
      return '/api/blade-resource/oss/endpoint/put-file-attach'
    },
    uploadHeaders () {
      const token = getToken()
      if (!token) return {}
      const bearer = 'Bearer ' + token
      return {
        Authorization: bearer,
        [website.tokenHeader]: bearer
      }
    },
    detailFields () {
      const detail = this.detail || {}
      return [
        { label: '演练名称', value: detail.drillName },
        { label: '演练日期', value: detail.drillDate },
        { label: '演练主题', value: detail.drillSubject, wide: true },
        { label: '组织部门', value: detail.organizeDeptName || this.deptLabel(detail.organizeDeptId) },
        { label: '完成状态', value: this.finishStatusLabel(detail.finishStatus) },
        { label: '创建时间', value: detail.createTime },
        { label: '更新时间', value: detail.updateTime }
      ]
    }
  },
  methods: {
    canAction (action) {
      if (!this.permission) return false
      return !!(
        this.permission[`emergency_drill_plan:${action}`] ||
        this.permission[`emergency_drill_plan_${action}`]
      )
    },
    handleAdd () {
      this.$refs.crud && this.$refs.crud.rowAdd()
    },
    beforeOpen (done, type) {
      this.openType = type
      if (type === 'edit' && this.apiConfig.getDetail && this.form.id) {
        this.apiConfig.getDetail(this.form.id).then(res => {
          this.form = (res.data && res.data.data) || res.data || {}
          done()
        }).catch(() => {
          done()
        })
      } else {
        done()
      }
    },
    rowSave (row, done, loading) {
      this.apiConfig.add(this.buildSavePayload(row)).then(() => {
        this.selectionClear()
        this.onLoad(this.page)
        this.$message.success('操作成功')
        done()
      }).catch(() => {
        loading && loading()
      })
    },
    rowUpdate (row, index, done, loading) {
      this.apiConfig.update(this.buildSavePayload(row, true)).then(() => {
        this.selectionClear()
        this.onLoad(this.page)
        this.$message.success('操作成功')
        done()
      }).catch(() => {
        loading && loading()
      })
    },
    buildSavePayload (row, includeId = false) {
      const payload = {
        drillName: row.drillName,
        drillDate: row.drillDate,
        organizeDeptId: row.organizeDeptId,
        organizeDeptName: this.resolveDeptName(row.organizeDeptId, row.organizeDeptName),
        drillSubject: row.drillSubject
      }
      if (includeId) {
        payload.id = row.id
      }
      return payload
    },
    syncDeptName (value) {
      this.$set(this.form, 'organizeDeptName', this.resolveDeptName(value, this.form.organizeDeptName))
    },
    resolveDeptName (value, fallback = '') {
      if (!value) return ''
      const column = this.option.column.find(item => item.prop === 'organizeDeptId') || {}
      const dicData = column.dicData || []
      const match = this.findDeptNode(dicData, value)
      return match ? (match.deptName || match.title || match.label || match.name || fallback) : fallback
    },
    findDeptNode (nodes, value) {
      if (!Array.isArray(nodes) || !value) return null
      for (const node of nodes) {
        if (String(node.id) === String(value) || String(node.value) === String(value)) {
          return node
        }
        const children = node.children || node.childrenList || node.childList || []
        const match = this.findDeptNode(children, value)
        if (match) return match
      }
      return null
    },
    deptLabel (value) {
      return this.resolveDeptName(value, '')
    },
    finishStatusLabel (value) {
      const item = FINISH_STATUS_OPTIONS.find(option => String(option.value) === String(value))
      return item ? item.label : '-'
    },
    imageList (value) {
      if (!value) return []
      if (Array.isArray(value)) return value.filter(Boolean)
      return String(value).split(',').map(item => item.trim()).filter(Boolean)
    },
    fileNameFromUrl (url, index) {
      const clean = String(url || '').split('?')[0]
      const name = clean.substring(clean.lastIndexOf('/') + 1)
      return name || `图片${index + 1}`
    },
    filesFromAttachments (attachments) {
      return this.imageList(attachments).map((url, index) => ({
        name: this.fileNameFromUrl(url, index),
        url
      }))
    },
    showDetail (row) {
      if (!row || !row.id) {
        this.$message.warning('请选择应急演练计划')
        return
      }
      this.detailVisible = true
      this.detailLoading = true
      this.detail = null
      getDetail(row.id).then(({ data }) => {
        if (data.code === 200) {
          this.detail = data.data || {}
        } else {
          this.$message.error(data.msg || '加载详情失败')
        }
      }).catch(() => {
        this.$message.error('加载详情失败')
      }).finally(() => {
        this.detailLoading = false
      })
    },
    openComplete (row) {
      if (!row || !row.id) {
        this.$message.warning('请选择应急演练计划')
        return
      }
      this.completeVisible = true
      this.completeLoading = true
      this.completeRow = { ...row }
      this.completeFiles = this.filesFromAttachments(row.attachments)
      getDetail(row.id).then(({ data }) => {
        if (data.code === 200) {
          this.completeRow = data.data || {}
          this.completeFiles = this.filesFromAttachments(this.completeRow.attachments)
        }
      }).finally(() => {
        this.completeLoading = false
      })
    },
    submitComplete () {
      if (!this.completeRow.id) {
        this.$message.warning('请选择应急演练计划')
        return
      }
      const payload = {
        id: this.completeRow.id,
        attachments: this.completeFiles.map(item => item.url).filter(Boolean).join(',')
      }
      this.completeLoading = true
      complete(payload).then(({ data }) => {
        if (!data || data.code === 200) {
          this.$message.success((data && data.msg) || '操作成功')
          this.completeVisible = false
          this.onLoad(this.page, this.query)
        } else {
          this.$message.error(data.msg || '操作失败')
        }
      }).finally(() => {
        this.completeLoading = false
      })
    },
    beforePhotoUpload (file) {
      const isImage = file.type && file.type.indexOf('image/') === 0
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.warning('请上传图片文件')
      }
      if (!isLt10M) {
        this.$message.warning('单张图片不能超过10MB')
      }
      return isImage && isLt10M
    },
    handlePhotoSuccess (res, file, fileList) {
      const url = this.resolveUploadUrl(res)
      if (url) {
        file.url = url
      }
      this.syncPhotoFiles(fileList)
    },
    handlePhotoRemove (file, fileList) {
      this.syncPhotoFiles(fileList)
    },
    handlePhotoPreview (file) {
      this.previewUrl = file.url || this.resolveUploadUrl(file.response)
      this.previewVisible = !!this.previewUrl
    },
    syncPhotoFiles (fileList) {
      this.completeFiles = fileList.map(item => ({
        ...item,
        url: item.url || this.resolveUploadUrl(item.response)
      })).filter(item => item.url)
    },
    resolveUploadUrl (res) {
      if (!res) return ''
      const data = res.data || {}
      return data.link || data.url || data.fileUrl || data.fullLink || ''
    },
    onImport () {
      this.excelBox = true
    },
    uploadAfter (res, done) {
      const response = res && res.data ? res.data : res
      if (res instanceof Error || (response && response.code && response.code !== 200)) {
        this.$message.error((response && (response.msg || response.message)) || '导入失败')
        done()
        return
      }
      this.$message.success((response && response.msg) || '导入成功')
      this.excelBox = false
      this.onLoad(this.page, this.query)
      done()
    },
    async handleTemplate () {
      this.templateLoading = true
      try {
        const res = await downloadImportTemplate()
        downloadXls(res.data, `应急演练计划导入模板_${Date.now()}.xlsx`)
        this.$message.success('模板下载成功')
      } catch (e) {
        this.$message.error((e && e.message) || '模板下载失败')
      } finally {
        this.templateLoading = false
      }
    },
    async handleExport () {
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `应急演练计划_${Date.now()}.xlsx`)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
p {
  margin: 0;
}
.attachment-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}
.attachment-thumb,
.detail-image {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
.attachment-thumb {
  width: 32px;
  height: 32px;
}
.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #909399;
  background: #f5f7fa;
}
.form-tip {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
.drill-photo-upload ::v-deep .el-upload--picture-card,
.drill-photo-upload ::v-deep .el-upload-list__item {
  width: 96px;
  height: 96px;
  line-height: 96px;
}
.detail-dialog {
  min-height: 320px;
  padding: 4px 8px 0;
}
.detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}
.detail-item {
  display: flex;
  min-height: 40px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
.detail-item--wide {
  grid-column: span 2;
}
.detail-item__label {
  flex: 0 0 110px;
  padding: 10px 12px;
  background: #f5f7fa;
  color: #606266;
}
.detail-item__value {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  color: #303133;
  word-break: break-all;
}
.detail-section {
  margin-top: 18px;
}
.detail-section__title {
  margin-bottom: 10px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.detail-image {
  width: 96px;
  height: 96px;
}
.preview-image {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}
</style>
